<script lang="ts">
  import { goto } from '$app/navigation';

  goto('/admin/users/admins');
</script>
